import './App.css';
import Header from './Components/Header';
import Dealerform from './Components/Dealerform';
import { Routes, Route } from 'react-router-dom';


function App() {
  return (
    <div className="App">
      <header className="App-header">
        <Header />
      </header>

      <main>
        <Routes>
          <Route 
            path="/" 
            element={
              
                <Dealerform />
             
            } 
          />
        </Routes>
      </main>
    </div>
  );
}

export default App;